import React from 'react';
import { Link } from 'react-router-dom';
import './VedaIndex.css';

const toolCategories = [
  {
    title: 'शिक्षा',
    subtitle: 'Shiksha — Phonetics',
    tools: [
      { name: 'वर्णक्रमः', english: 'Varnakrama', path: '/varnakrama', desc: 'Syllable-wise analysis' },
      { name: 'वर्णमालिका', english: 'Varnamalika', path: '/Varnamalika', desc: 'Alphabet arrangement' },
      { name: 'प्रत्याहारः', english: 'Pratyahara', path: '/pratyahara', desc: 'Letter groupings from Maheshwara Sutras' },
    ],
  },
  {
    title: 'व्याकरणम्',
    subtitle: 'Vyakarana — Grammar',
    tools: [
      { name: 'सन्धिः', english: 'Sandhi', path: '/sandhi', desc: 'Word joining rules' },
      { name: 'विभक्तिः', english: 'Vibhakti', path: '/vibhakti', desc: 'Grammatical case analysis' },
      { name: 'शब्दाधिकारः', english: 'Shabdaadhikaaraha', path: '/Shabdaadhikaaraha', desc: 'Noun paradigms' },
      { name: 'सुबन्तरूपाणि', english: 'Subantarupaani', path: '/Subantarupaani', desc: 'Declension forms' },
      { name: 'कृदन्तः', english: 'Krudantha', path: '/Krudantha', desc: 'Verbal derivatives' },
      { name: 'घिरूपम्', english: 'GhiRupa', path: '/GhiRupa', desc: 'Ghi-ending forms' },
    ],
  },
  {
    title: 'पाठक्रमः',
    subtitle: 'Paathakrama — Recitation',
    tools: [
      { name: 'पदम्', english: 'Padam', path: '/padam', desc: 'Pada-wise analysis' },
      { name: 'विकृतिपाठः', english: 'Vikruti Paatham', path: '/vikruti', desc: 'Vikruti recitation patterns' },
      { name: 'क्रमः', english: 'Krama', path: '/krama', desc: 'Krama recitation' },
      { name: 'जटा', english: 'Jata', path: '/jata', desc: 'Jata recitation' },
      { name: 'घनः', english: 'Ghana', path: '/ghana', desc: 'Ghana recitation' },
    ],
  },
  {
    title: 'वेद सूची',
    subtitle: 'Veda Soochi — Text Index',
    tools: [
      { name: 'वेद सूची', english: 'Veda Index', path: '/veda-index', desc: 'Browse Vedic text hierarchy — Shakha, Kanda, Prapathaka, Anuvaka' },
    ],
  },
  {
    title: 'अभ्यासः',
    subtitle: 'Abhyaasa — Practice',
    tools: [
      { name: 'स्पर्धा', english: 'Demo', path: '/spardha', desc: 'Competitions and demos' },
    ],
  },
];

const VedaIndex = () => {
  return (
    <div className="veda-index">
      <h2 className="veda-index-title">उपकरणसूचिः — Tool Index</h2>
      {toolCategories.map((category, catIdx) => (
        <section key={catIdx} className="veda-index-section">
          <h3 className="veda-index-section-title">
            {category.title} <span className="veda-index-section-subtitle">{category.subtitle}</span>
          </h3>
          <div className="veda-index-grid">
            {category.tools.map((tool, toolIdx) => (
              <Link key={toolIdx} to={tool.path} className="veda-index-card">
                <div className="veda-index-card-name">{tool.name}</div>
                <div className="veda-index-card-english">{tool.english}</div>
                <div className="veda-index-card-desc">{tool.desc}</div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default VedaIndex;
